var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvcIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M62.5 25V55C62.5 59.15 59.15 62.5 55 62.5H27.5L17.5 52.5V25C17.5 20.85 20.85 17.5 25 17.5H55C59.15 17.5 62.5 20.85 62.5 25Z",
    fill: "#38383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.875 54.2675L25.7325 35.1275C25.2625 34.6575 25 34.0225 25 33.36V30C25 27.2375 27.2375 25 30 25H50C52.7625 25 55 27.2375 55 30V50C55 52.7625 52.7625 55 50 55H46.6425C45.98 55 45.3425 54.7375 44.875 54.2675Z",
    fill: "#9AFF42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 37.5V55C17.5 59.15 20.85 62.5 25 62.5H42.5L17.5 37.5ZM25 57.5C23.625 57.5 22.5 56.375 22.5 55C22.5 53.625 23.625 52.5 25 52.5C26.375 52.5 27.5 53.625 27.5 55C27.5 56.375 26.375 57.5 25 57.5Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIcon5);
export default __webpack_public_path__ + "static/media/svc_icon5.6f5a3308293a809b5a65afc3a0ba001f.svg";
export { ForwardRef as ReactComponent };